import { render, staticRenderFns } from "./CbsBudgetRequestAccess.vue?vue&type=template&id=30894e34&scoped=true"
import script from "./CbsBudgetRequestAccess.vue?vue&type=script&lang=js"
export * from "./CbsBudgetRequestAccess.vue?vue&type=script&lang=js"
import style0 from "./CbsBudgetRequestAccess.vue?vue&type=style&index=0&id=30894e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30894e34",
  null
  
)

export default component.exports